import Result from '@/components/Result/Result';

import './StoreCartLoadError.scss';

const StoreCartLoadError = () => (
  <div className="store-cart-load-error">
    <Result />
  </div>
);

StoreCartLoadError.displayName = 'StoreCartLoadError';

export default StoreCartLoadError;
